var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitePhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Phone",
    d: "M120.682,62.529c3.48-6.22,15.7-12.046,22.67-12.17s6.747,9.21,6.737,9.23c0,0,8.48-2.27,17.857-11.643s11.64-17.853,11.64-17.853c-.023.01-9.353.23-9.233-6.743S176.305,4.164,182.529.684s18.42,6.847,17.413,19.453-8.853,28.159-20.25,39.556-26.953,19.25-39.556,20.253-22.93-11.19-19.453-17.416",
    transform: "translate(-120 -0.004)",
    fill: "#f5f5f5",
    opacity: 0.243
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePhoneIcon);
export default __webpack_public_path__ + "static/media/WhitePhoneIcon.54e76c509266553a56f48fb31b033ce7.svg";
export { ForwardRef as ReactComponent };